// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UTLTf","col":"styles_col__HeS9_"};